export default "__VITE_ASSET__udUgdOiG__"